module.exports = __webpack_public_path__ + "static/media/vf_wdressshoes_core.9d8e529f.svg";